import type { TCargoType } from 'api/swagger';

export const CARGO_TYPE_LABELS: Record<TCargoType, string> = {
  FTL: 'FTL',
  LTL: 'LTL',
  CONTAINER: 'Container',
  PART_LOAD: 'Part load',
};

export const getCargoTypeLabel = (type: TCargoType): string => CARGO_TYPE_LABELS[type] || type;
